import BitBoxUtility from '../../utilities/BitBoxUtility.js';
import IframeManager from '../../utilities/IframeManager.js';
/**
 * This class is used for checking cookie consent in bitbox markets.
 */
export default class BitboxCookieConsentService {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     * @param options.cache Cache store.
     */
    constructor(options) {
        this.endpoint = options.endpoint;
        this.cache = options.cache;
    }
    /**
     * Checks if cookie consent meets a provided level.
     *
     * @param consentLevel Consent level (1-4).
     * @returns Promise of boolean.
     */
    async hasCookieConsent(consentLevel) {
        const iframe = await this.createIframe();
        const result = await BitBoxUtility.readIframeContext(iframe);
        const cookieConsent = result.CookieConsent;
        switch (consentLevel) {
            // These numbers mirror the levels used by OneWeb.
            case 1:
                return cookieConsent.necessary;
            case 2:
                return cookieConsent.statistics;
            case 3:
                return cookieConsent.preferences;
            case 4:
                return cookieConsent.marketing;
        }
    }
    /**
     * Creates and returns iframe element.
     *
     * @returns Promise with iframe.
     */
    async createIframe() {
        if (this.iframeManager && this.iframeManager.url !== this.endpoint) {
            this.iframeManager.disconnect();
            this.iframeManager = null;
        }
        if (!this.iframeManager) {
            this.iframeManager = new IframeManager(this.endpoint, this.cache);
        }
        return await this.iframeManager.getIframe();
    }
}
//# sourceMappingURL=BitboxCookieConsentService.js.map